import React, { useEffect } from 'react';
import { FileText, Users, ClipboardList, GraduationCap } from 'lucide-react';
import SEO from '../components/SEO';
import RichText from '../components/RichText';
import CtaSection from '../components/CtaSection';
import PageHero from '../components/PageHero';
import { rgpdContent } from '../data/siteContent';
import './About.css';

const icons = { FileText, Users, ClipboardList, GraduationCap };

const RGPD = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <SEO
        page="rgpd"
        breadcrumb={[{ name: 'Accueil', path: '/' }, { name: 'RGPD', path: '/rgpd' }]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Mise en conformité RGPD et DPO externe',
          serviceType: 'Conseil RGPD',
          provider: { '@type': 'LocalBusiness', name: 'Symplicity', url: 'https://www.symplicity.fr' },
          areaServed: ['Essonne', 'Seine-et-Marne', 'Paris', 'Île-de-France'],
          description: 'Audit de conformité, DPO externalisé certifié CNIL, tenue des registres et sensibilisation des équipes.'
        }}
      />
      <div className="service-page theme-pink" data-testid="rgpd-page">

        <PageHero
          symbol="pink"
          title={rgpdContent.title}
          subtitle={rgpdContent.subtitle}
          testId="rgpd-hero"
        />

        <section className="section">
          <div className="container">
            <div className="panel fade-in-up">
              <RichText blocks={rgpdContent.blocks} />
            </div>
          </div>
        </section>

        <section className="section section-alt">
          <div className="container">
            <span className="eyebrow">Notre accompagnement</span>
            <h2 className="section-title">Un parcours de conformité complet</h2>
            <div className="highlights-grid">
              {rgpdContent.highlights.map((item, index) => {
                const Icon = icons[item.icon];
                return (
                  <div key={item.title} className="highlight-card glass fade-in-up" style={{ animationDelay: `${index * 0.08}s` }}>
                    <div className="highlight-icon"><Icon size={28} /></div>
                    <h3 className="highlight-title">{item.title}</h3>
                    <p className="highlight-description">{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <CtaSection title={rgpdContent.ctaTitle} testId="rgpd-cta" />
      </div>
    </>
  );
};

export default RGPD;
